import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import { FIELD_DATE_TYPE } from 'Component/FieldDate/FieldDate.config';
import {
    ProductCustomizableOption as SourceProductCustomizableOption
} from 'SourceComponent/ProductCustomizableOption/ProductCustomizableOption.component';
import { validateEmail } from 'Util/Validator';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import { CONFIG_FIELD_TYPE } from './ProductCustomizableOption.config';

import './ProductCustomizableOption.override.style';

/** @namespace Elganso/Component/ProductCustomizableOption/Component */
export class ProductCustomizableOptionComponent extends SourceProductCustomizableOption {
    renderMap = {
        [CONFIG_FIELD_TYPE.text]: this.renderDefaultEmail.bind(this),
        [CONFIG_FIELD_TYPE.textarea]: this.renderDefaultValue.bind(this),
        [CONFIG_FIELD_TYPE.date]: this.renderDatePicker.bind(this, FIELD_DATE_TYPE.date),
        [CONFIG_FIELD_TYPE.dateTime]: this.renderDatePicker.bind(this, FIELD_DATE_TYPE.dateTime),
        [CONFIG_FIELD_TYPE.time]: this.renderDatePicker.bind(this, FIELD_DATE_TYPE.time),

        [CONFIG_FIELD_TYPE.file]: this.renderFileValue.bind(this),
        [CONFIG_FIELD_TYPE.select]: this.renderSelectValues.bind(this),
        [CONFIG_FIELD_TYPE.radio]: this.renderRadioValues.bind(this),
        [CONFIG_FIELD_TYPE.checkbox]: this.renderCheckboxValues.bind(this),
        [CONFIG_FIELD_TYPE.multi]: this.renderCheckboxValues.bind(this)
    };

    // Se cambia el input tipo text por input tipo email para el producto customizable
    // Si en el futuro hubiera opciones customizable tipo text habría que sobreescribir aqui
    renderDefaultEmail(option) {
        const {
            title, isRequired, uid
        } = this.props;
        const label = this.getLabel(option, title);

        return (
            <>
                { this.renderOptionGroupTitle(label) }
                <Field
                  type={ FIELD_TYPE.email }
                  attr={ {
                      id: uid,
                      name: uid,
                      placeholder: ''
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired,
                      inputType: VALIDATION_INPUT_TYPE.email,
                      match: (value) => validateEmail(value)
                  } }
                  events={ { onChange: this.updateValues.bind(this) } }
                  addRequiredTag
                />

                { /* <Field
                  type={ fieldType }
                  validationRule={ {
                      isRequired,
                      range: { max: max_characters > 0 ? max_characters : null }
                  } }
                  attr={ {
                      id: uid,
                      name: uid,
                      placeholder: ''
                  } }
                  subLabel={ subLabel }
                  events={ {
                      onChange: this.updateValues.bind(this)
                  } }
                  validateOn={ ['onBlur', 'onChange'] }
                /> */ }
            </>
        );
    }

    render() {
        const { options, type, title } = this.props;
        const render = this.renderMap[type];

        if (!render) {
            return null;
        }

        const renderTitle = title
            && (type === CONFIG_FIELD_TYPE.select
            || type === CONFIG_FIELD_TYPE.radio
            || type === CONFIG_FIELD_TYPE.checkbox
            || type === CONFIG_FIELD_TYPE.multi);

        return (
            <div block="ProductCustomizableItem" elem="Wrapper">
                { renderTitle && this.renderOptionGroupTitle(title) }
                { options && render(options) }
            </div>
        );
    }
}

export default ProductCustomizableOptionComponent;
